import {Injectable} from '@angular/core';
import appUtil from '../../util/app.util';

@Injectable({
  providedIn: 'root',
})
export class AppStorageService {
  setItem(storageName: string, item: unknown): void {
    try {
      localStorage.setItem(storageName, JSON.stringify(item));
    } catch (error) {
      console.error('Error in setting item in Lcoalstorage', error);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setItems(keys: string[], values: any[]): void {
    keys.forEach((key: string, index: number) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      this.setItem(key, values[index]);
    });
  }

  removeItems(keys: string[]): void {
    keys.forEach((key: string) => {
      this.removeItem(key);
    });
  }

  getItem(storageName: string): unknown {
    const item = localStorage.getItem(storageName) ?? '';
    if (!appUtil.isEmpty(item)) {
      return JSON.parse(item);
    }
    return item;
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
